(() => {
  const clamp = (value, min, max) =>
    Math.min(Math.max(value, min), max);

  const hexToRgb = (hex) => {
    const value = hex.replace('#', '').trim();

    if (value.length === 3) {
      return {
        r: parseInt(value[0] + value[0], 16),
        g: parseInt(value[1] + value[1], 16),
        b: parseInt(value[2] + value[2], 16)
      };
    }

    return {
      r: parseInt(value.substring(0, 2), 16),
      g: parseInt(value.substring(2, 4), 16),
      b: parseInt(value.substring(4, 6), 16)
    };
  };

  const mixColor = (start, end, progress) => {
    const r = Math.round(start.r + (end.r - start.r) * progress);
    const g = Math.round(start.g + (end.g - start.g) * progress);
    const b = Math.round(start.b + (end.b - start.b) * progress);

    return `rgb(${r}, ${g}, ${b})`;
  };

  const initThreadScrollHero = (section) => {
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';
const announcementBar = document.querySelector(
  '.announcement-bar-wrapper'
);

if (announcementBar) {
  document.documentElement.style.setProperty(
    '--height-announcement',
    `${announcementBar.offsetHeight}px`
  );
} else {
  document.documentElement.style.setProperty(
    '--height-announcement',
    '0px'
  );
}
    const background = section.querySelector('[data-thread-background]');
    const eyes = section.querySelector('[data-thread-eyes]');
    const reveal = section.querySelector('[data-thread-reveal]');

    if (!background) return;

    const styles = getComputedStyle(section);

    const startColor = styles
      .getPropertyValue('--thread-start-color')
      .trim();

    const endColor = styles
      .getPropertyValue('--thread-end-color')
      .trim();

    const startRgb = hexToRgb(startColor);
    const endRgb = hexToRgb(endColor);

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    let ticking = false;

    const update = () => {
      if (reducedMotion.matches) return;

      const rect = section.getBoundingClientRect();
      const stage = section.querySelector(
  '.con-thread-scroll-hero__stage'
);

const stageHeight = stage
  ? stage.getBoundingClientRect().height
  : window.innerHeight;

const scrollableDistance =
  section.getBoundingClientRect().height - stageHeight;

      if (scrollableDistance <= 0) return;

      const progress = clamp(
        -rect.top / scrollableDistance,
        0,
        1
      );

      const backgroundProgress = clamp(
  progress / 0.68,
  0,
  1
);

      background.style.backgroundColor = mixColor(
        startRgb,
        endRgb,
        backgroundProgress
      );

      if (eyes) {
        const eyeFade = clamp(
          1 - ((progress - 0.52) / 0.25),
          0,
          1
        );

        eyes.style.opacity = eyeFade;
      }

      if (reveal) {
        const revealProgress = clamp(
          (progress - 0.82) / 0.14,
          0,
          1
        );

        reveal.style.opacity = revealProgress;
        reveal.style.transform =
          `translateY(${(1 - revealProgress) * 16}px)`;
      }
    };

    const requestUpdate = () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    window.addEventListener('scroll', requestUpdate, {
      passive: true
    });

    window.addEventListener('resize', requestUpdate);

    update();
  };

  const initAllThreadScrollHeroes = (root = document) => {
    root
      .querySelectorAll('[data-thread-scroll-hero]')
      .forEach(initThreadScrollHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllThreadScrollHeroes();
    });
  } else {
    initAllThreadScrollHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllThreadScrollHeroes(event.target);
  });
})();